import { useLazyQuery, useQuery } from "@apollo/client";
import { REGIONS } from "../departments.queries";
import {
  RegionsQuery,
  RegionsQueryVariables,
} from "../../../__generated__/RegionsQuery";

export const useRegions = () => {
  return useQuery<RegionsQuery, RegionsQueryVariables>(REGIONS, {
    variables: {
      where: {},
    },
    fetchPolicy: "network-only",
  });
};

export const useLazyRegions = () => {
  return useLazyQuery<RegionsQuery, RegionsQueryVariables>(REGIONS);
};
